import { Interpolation } from '@emotion/react';

const styles = {
  CartCounter: {
    position: ['fixed', 'relative', 'relative'],
    top: ['85vh', '0', '0'],
    left: ['80vw', '0', '0'],
    border: '0 solid',
    borderRadius: [10, 6, 6],
    height: ['60px', '32px', '32px'],
    width: ['60px', 'auto', 'auto']
  } as Interpolation<any>
};

export default styles;
